import MetaDescription from './meta-description.container';
export default MetaDescription;
